import api from "./api"
import Icons from "./Icons"


export default function WishListBtn (props)  {
  const { isAdd = false, productId = '', onSuccess } = props

  const reviewRequest = async (params) => {
    try {
      const token = localStorage.getItem('token'); 
      const res = await api.patch(`/products/${productId}/review`, params, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      })
      if (res.status === 200) {
        onSuccess(res.data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleChangeWishListStatus = (e) => {
    e.stopPropagation();
    if (!productId) {
      return
    }
    reviewRequest({
      wishlist: !isAdd
    })
  }

  return (
    <div className="wishList-icon-wrapper" onClick={(e) => handleChangeWishListStatus(e)}>
      { isAdd ? <Icons.WishListAdded className="wishList-icon" /> : <Icons.Wishlist className="wishList-icon" />}
    </div>
  )
}
